// source: importer/importer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.importer.AutoCollectRequest', null, global);
goog.exportSymbol('proto.importer.AutoCollectResponse', null, global);
goog.exportSymbol('proto.importer.CancelImportWizardRequest', null, global);
goog.exportSymbol('proto.importer.CancelImportWizardResponse', null, global);
goog.exportSymbol('proto.importer.FinalizeImportWizardRequest', null, global);
goog.exportSymbol('proto.importer.FinalizeImportWizardResponse', null, global);
goog.exportSymbol('proto.importer.Framework', null, global);
goog.exportSymbol('proto.importer.GetFrameworksRequest', null, global);
goog.exportSymbol('proto.importer.GetFrameworksResponse', null, global);
goog.exportSymbol('proto.importer.GetImportWizardControlsRequest', null, global);
goog.exportSymbol('proto.importer.GetImportWizardControlsResponse', null, global);
goog.exportSymbol('proto.importer.GetImportWizardEvidenceRequest', null, global);
goog.exportSymbol('proto.importer.GetImportWizardEvidenceResponse', null, global);
goog.exportSymbol('proto.importer.GetImportWizardPoliciesRequest', null, global);
goog.exportSymbol('proto.importer.GetImportWizardPoliciesResponse', null, global);
goog.exportSymbol('proto.importer.GetImportWizardRequest', null, global);
goog.exportSymbol('proto.importer.GetImportWizardResponse', null, global);
goog.exportSymbol('proto.importer.GetImportableTypesRequest', null, global);
goog.exportSymbol('proto.importer.GetImportableTypesResponse', null, global);
goog.exportSymbol('proto.importer.ImportControl', null, global);
goog.exportSymbol('proto.importer.ImportEvidence', null, global);
goog.exportSymbol('proto.importer.ImportPolicy', null, global);
goog.exportSymbol('proto.importer.ImportWizardStartRequest', null, global);
goog.exportSymbol('proto.importer.ImportWizardStartResponse', null, global);
goog.exportSymbol('proto.importer.ImportableType', null, global);
goog.exportSymbol('proto.importer.ImporterState', null, global);
goog.exportSymbol('proto.importer.PaginationConfig', null, global);
goog.exportSymbol('proto.importer.Status', null, global);
goog.exportSymbol('proto.importer.UpdateImportWizardControlsRequest', null, global);
goog.exportSymbol('proto.importer.UpdateImportWizardEvidenceRequest', null, global);
goog.exportSymbol('proto.importer.UpdateImportWizardPoliciesRequest', null, global);
goog.exportSymbol('proto.importer.UpdateImportWizardResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.PaginationConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.PaginationConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.PaginationConfig.displayName = 'proto.importer.PaginationConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.ImportWizardStartRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.importer.ImportWizardStartRequest.repeatedFields_, null);
};
goog.inherits(proto.importer.ImportWizardStartRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.ImportWizardStartRequest.displayName = 'proto.importer.ImportWizardStartRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.ImportWizardStartResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.ImportWizardStartResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.ImportWizardStartResponse.displayName = 'proto.importer.ImportWizardStartResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.GetImportWizardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.GetImportWizardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.GetImportWizardRequest.displayName = 'proto.importer.GetImportWizardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.GetImportWizardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.GetImportWizardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.GetImportWizardResponse.displayName = 'proto.importer.GetImportWizardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.ImportPolicy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.importer.ImportPolicy.repeatedFields_, null);
};
goog.inherits(proto.importer.ImportPolicy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.ImportPolicy.displayName = 'proto.importer.ImportPolicy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.ImportControl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.importer.ImportControl.repeatedFields_, null);
};
goog.inherits(proto.importer.ImportControl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.ImportControl.displayName = 'proto.importer.ImportControl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.ImportEvidence = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.importer.ImportEvidence.repeatedFields_, null);
};
goog.inherits(proto.importer.ImportEvidence, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.ImportEvidence.displayName = 'proto.importer.ImportEvidence';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.GetImportWizardPoliciesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.GetImportWizardPoliciesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.GetImportWizardPoliciesRequest.displayName = 'proto.importer.GetImportWizardPoliciesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.GetImportWizardPoliciesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.importer.GetImportWizardPoliciesResponse.repeatedFields_, null);
};
goog.inherits(proto.importer.GetImportWizardPoliciesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.GetImportWizardPoliciesResponse.displayName = 'proto.importer.GetImportWizardPoliciesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.GetImportWizardControlsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.GetImportWizardControlsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.GetImportWizardControlsRequest.displayName = 'proto.importer.GetImportWizardControlsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.GetImportWizardControlsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.importer.GetImportWizardControlsResponse.repeatedFields_, null);
};
goog.inherits(proto.importer.GetImportWizardControlsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.GetImportWizardControlsResponse.displayName = 'proto.importer.GetImportWizardControlsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.GetImportWizardEvidenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.GetImportWizardEvidenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.GetImportWizardEvidenceRequest.displayName = 'proto.importer.GetImportWizardEvidenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.GetImportWizardEvidenceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.importer.GetImportWizardEvidenceResponse.repeatedFields_, null);
};
goog.inherits(proto.importer.GetImportWizardEvidenceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.GetImportWizardEvidenceResponse.displayName = 'proto.importer.GetImportWizardEvidenceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.GetImportableTypesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.GetImportableTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.GetImportableTypesRequest.displayName = 'proto.importer.GetImportableTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.ImportableType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.ImportableType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.ImportableType.displayName = 'proto.importer.ImportableType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.GetImportableTypesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.importer.GetImportableTypesResponse.repeatedFields_, null);
};
goog.inherits(proto.importer.GetImportableTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.GetImportableTypesResponse.displayName = 'proto.importer.GetImportableTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.GetFrameworksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.GetFrameworksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.GetFrameworksRequest.displayName = 'proto.importer.GetFrameworksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.Framework = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.Framework, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.Framework.displayName = 'proto.importer.Framework';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.GetFrameworksResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.importer.GetFrameworksResponse.repeatedFields_, null);
};
goog.inherits(proto.importer.GetFrameworksResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.GetFrameworksResponse.displayName = 'proto.importer.GetFrameworksResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.CancelImportWizardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.CancelImportWizardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.CancelImportWizardRequest.displayName = 'proto.importer.CancelImportWizardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.CancelImportWizardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.CancelImportWizardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.CancelImportWizardResponse.displayName = 'proto.importer.CancelImportWizardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.FinalizeImportWizardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.importer.FinalizeImportWizardRequest.repeatedFields_, null);
};
goog.inherits(proto.importer.FinalizeImportWizardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.FinalizeImportWizardRequest.displayName = 'proto.importer.FinalizeImportWizardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.FinalizeImportWizardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.FinalizeImportWizardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.FinalizeImportWizardResponse.displayName = 'proto.importer.FinalizeImportWizardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.AutoCollectRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.AutoCollectRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.AutoCollectRequest.displayName = 'proto.importer.AutoCollectRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.AutoCollectResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.AutoCollectResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.AutoCollectResponse.displayName = 'proto.importer.AutoCollectResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.UpdateImportWizardPoliciesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.importer.UpdateImportWizardPoliciesRequest.repeatedFields_, null);
};
goog.inherits(proto.importer.UpdateImportWizardPoliciesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.UpdateImportWizardPoliciesRequest.displayName = 'proto.importer.UpdateImportWizardPoliciesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.UpdateImportWizardControlsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.importer.UpdateImportWizardControlsRequest.repeatedFields_, null);
};
goog.inherits(proto.importer.UpdateImportWizardControlsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.UpdateImportWizardControlsRequest.displayName = 'proto.importer.UpdateImportWizardControlsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.UpdateImportWizardEvidenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.importer.UpdateImportWizardEvidenceRequest.repeatedFields_, null);
};
goog.inherits(proto.importer.UpdateImportWizardEvidenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.UpdateImportWizardEvidenceRequest.displayName = 'proto.importer.UpdateImportWizardEvidenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.importer.UpdateImportWizardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.importer.UpdateImportWizardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.importer.UpdateImportWizardResponse.displayName = 'proto.importer.UpdateImportWizardResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.PaginationConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.PaginationConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.PaginationConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.PaginationConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageSize: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    totalCount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.PaginationConfig}
 */
proto.importer.PaginationConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.PaginationConfig;
  return proto.importer.PaginationConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.PaginationConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.PaginationConfig}
 */
proto.importer.PaginationConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.PaginationConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.PaginationConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.PaginationConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.PaginationConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 page_size = 1;
 * @return {number}
 */
proto.importer.PaginationConfig.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.importer.PaginationConfig} returns this
 */
proto.importer.PaginationConfig.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.importer.PaginationConfig.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.importer.PaginationConfig} returns this
 */
proto.importer.PaginationConfig.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 total_count = 3;
 * @return {number}
 */
proto.importer.PaginationConfig.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.importer.PaginationConfig} returns this
 */
proto.importer.PaginationConfig.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.importer.ImportWizardStartRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.ImportWizardStartRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.ImportWizardStartRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.ImportWizardStartRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.ImportWizardStartRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    objectTypesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    frameworkIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.ImportWizardStartRequest}
 */
proto.importer.ImportWizardStartRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.ImportWizardStartRequest;
  return proto.importer.ImportWizardStartRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.ImportWizardStartRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.ImportWizardStartRequest}
 */
proto.importer.ImportWizardStartRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addObjectTypes(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addFrameworkIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.ImportWizardStartRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.ImportWizardStartRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.ImportWizardStartRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.ImportWizardStartRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObjectTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getFrameworkIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string object_types = 1;
 * @return {!Array<string>}
 */
proto.importer.ImportWizardStartRequest.prototype.getObjectTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.importer.ImportWizardStartRequest} returns this
 */
proto.importer.ImportWizardStartRequest.prototype.setObjectTypesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportWizardStartRequest} returns this
 */
proto.importer.ImportWizardStartRequest.prototype.addObjectTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.ImportWizardStartRequest} returns this
 */
proto.importer.ImportWizardStartRequest.prototype.clearObjectTypesList = function() {
  return this.setObjectTypesList([]);
};


/**
 * repeated string framework_ids = 2;
 * @return {!Array<string>}
 */
proto.importer.ImportWizardStartRequest.prototype.getFrameworkIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.importer.ImportWizardStartRequest} returns this
 */
proto.importer.ImportWizardStartRequest.prototype.setFrameworkIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportWizardStartRequest} returns this
 */
proto.importer.ImportWizardStartRequest.prototype.addFrameworkIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.ImportWizardStartRequest} returns this
 */
proto.importer.ImportWizardStartRequest.prototype.clearFrameworkIdsList = function() {
  return this.setFrameworkIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.ImportWizardStartResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.ImportWizardStartResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.ImportWizardStartResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.ImportWizardStartResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.ImportWizardStartResponse}
 */
proto.importer.ImportWizardStartResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.ImportWizardStartResponse;
  return proto.importer.ImportWizardStartResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.ImportWizardStartResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.ImportWizardStartResponse}
 */
proto.importer.ImportWizardStartResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.ImportWizardStartResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.ImportWizardStartResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.ImportWizardStartResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.ImportWizardStartResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.importer.ImportWizardStartResponse.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportWizardStartResponse} returns this
 */
proto.importer.ImportWizardStartResponse.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.GetImportWizardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.GetImportWizardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.GetImportWizardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pagination: (f = msg.getPagination()) && proto.importer.PaginationConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.GetImportWizardRequest}
 */
proto.importer.GetImportWizardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.GetImportWizardRequest;
  return proto.importer.GetImportWizardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.GetImportWizardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.GetImportWizardRequest}
 */
proto.importer.GetImportWizardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = new proto.importer.PaginationConfig;
      reader.readMessage(value,proto.importer.PaginationConfig.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.GetImportWizardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.GetImportWizardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.GetImportWizardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.importer.PaginationConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.importer.GetImportWizardRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.GetImportWizardRequest} returns this
 */
proto.importer.GetImportWizardRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PaginationConfig pagination = 2;
 * @return {?proto.importer.PaginationConfig}
 */
proto.importer.GetImportWizardRequest.prototype.getPagination = function() {
  return /** @type{?proto.importer.PaginationConfig} */ (
    jspb.Message.getWrapperField(this, proto.importer.PaginationConfig, 2));
};


/**
 * @param {?proto.importer.PaginationConfig|undefined} value
 * @return {!proto.importer.GetImportWizardRequest} returns this
*/
proto.importer.GetImportWizardRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.importer.GetImportWizardRequest} returns this
 */
proto.importer.GetImportWizardRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.importer.GetImportWizardRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.GetImportWizardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.GetImportWizardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.GetImportWizardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pagination: (f = msg.getPagination()) && proto.importer.PaginationConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.GetImportWizardResponse}
 */
proto.importer.GetImportWizardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.GetImportWizardResponse;
  return proto.importer.GetImportWizardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.GetImportWizardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.GetImportWizardResponse}
 */
proto.importer.GetImportWizardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = /** @type {!proto.importer.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = new proto.importer.PaginationConfig;
      reader.readMessage(value,proto.importer.PaginationConfig.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.GetImportWizardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.GetImportWizardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.GetImportWizardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.importer.PaginationConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.importer.GetImportWizardResponse.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.GetImportWizardResponse} returns this
 */
proto.importer.GetImportWizardResponse.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Status status = 2;
 * @return {!proto.importer.Status}
 */
proto.importer.GetImportWizardResponse.prototype.getStatus = function() {
  return /** @type {!proto.importer.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.importer.Status} value
 * @return {!proto.importer.GetImportWizardResponse} returns this
 */
proto.importer.GetImportWizardResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional PaginationConfig pagination = 3;
 * @return {?proto.importer.PaginationConfig}
 */
proto.importer.GetImportWizardResponse.prototype.getPagination = function() {
  return /** @type{?proto.importer.PaginationConfig} */ (
    jspb.Message.getWrapperField(this, proto.importer.PaginationConfig, 3));
};


/**
 * @param {?proto.importer.PaginationConfig|undefined} value
 * @return {!proto.importer.GetImportWizardResponse} returns this
*/
proto.importer.GetImportWizardResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.importer.GetImportWizardResponse} returns this
 */
proto.importer.GetImportWizardResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.importer.GetImportWizardResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.importer.ImportPolicy.repeatedFields_ = [3,8,9,10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.ImportPolicy.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.ImportPolicy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.ImportPolicy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.ImportPolicy.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    recordStatusType: jspb.Message.getFieldWithDefault(msg, 2, ""),
    linkedControlIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    isUserSelected: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    url: jspb.Message.getFieldWithDefault(msg, 6, ""),
    name: jspb.Message.getFieldWithDefault(msg, 7, ""),
    unlinkedControlIdsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    linkedPolicyDocIdsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    unlinkedPolicyDocIdsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.ImportPolicy}
 */
proto.importer.ImportPolicy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.ImportPolicy;
  return proto.importer.ImportPolicy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.ImportPolicy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.ImportPolicy}
 */
proto.importer.ImportPolicy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecordStatusType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addLinkedControlIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsUserSelected(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addUnlinkedControlIds(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addLinkedPolicyDocIds(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addUnlinkedPolicyDocIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.ImportPolicy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.ImportPolicy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.ImportPolicy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.ImportPolicy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRecordStatusType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLinkedControlIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIsUserSelected();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUnlinkedControlIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getLinkedPolicyDocIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getUnlinkedPolicyDocIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.importer.ImportPolicy.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string record_status_type = 2;
 * @return {string}
 */
proto.importer.ImportPolicy.prototype.getRecordStatusType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.setRecordStatusType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string linked_control_ids = 3;
 * @return {!Array<string>}
 */
proto.importer.ImportPolicy.prototype.getLinkedControlIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.setLinkedControlIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.addLinkedControlIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.clearLinkedControlIdsList = function() {
  return this.setLinkedControlIdsList([]);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.importer.ImportPolicy.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool is_user_selected = 5;
 * @return {boolean}
 */
proto.importer.ImportPolicy.prototype.getIsUserSelected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.setIsUserSelected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string url = 6;
 * @return {string}
 */
proto.importer.ImportPolicy.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string name = 7;
 * @return {string}
 */
proto.importer.ImportPolicy.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated string unlinked_control_ids = 8;
 * @return {!Array<string>}
 */
proto.importer.ImportPolicy.prototype.getUnlinkedControlIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.setUnlinkedControlIdsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.addUnlinkedControlIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.clearUnlinkedControlIdsList = function() {
  return this.setUnlinkedControlIdsList([]);
};


/**
 * repeated string linked_policy_doc_ids = 9;
 * @return {!Array<string>}
 */
proto.importer.ImportPolicy.prototype.getLinkedPolicyDocIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.setLinkedPolicyDocIdsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.addLinkedPolicyDocIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.clearLinkedPolicyDocIdsList = function() {
  return this.setLinkedPolicyDocIdsList([]);
};


/**
 * repeated string unlinked_policy_doc_ids = 10;
 * @return {!Array<string>}
 */
proto.importer.ImportPolicy.prototype.getUnlinkedPolicyDocIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.setUnlinkedPolicyDocIdsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.addUnlinkedPolicyDocIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.ImportPolicy} returns this
 */
proto.importer.ImportPolicy.prototype.clearUnlinkedPolicyDocIdsList = function() {
  return this.setUnlinkedPolicyDocIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.importer.ImportControl.repeatedFields_ = [3,4,10,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.ImportControl.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.ImportControl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.ImportControl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.ImportControl.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    objective: jspb.Message.getFieldWithDefault(msg, 2, ""),
    linkedPolicyIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    linkedEvidenceIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    url: jspb.Message.getFieldWithDefault(msg, 5, ""),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    recordStatusType: jspb.Message.getFieldWithDefault(msg, 7, ""),
    isUserSelected: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    modelId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    unlinkedEvidenceIdsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    unlinkedPolicyIdsList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.ImportControl}
 */
proto.importer.ImportControl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.ImportControl;
  return proto.importer.ImportControl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.ImportControl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.ImportControl}
 */
proto.importer.ImportControl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjective(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addLinkedPolicyIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addLinkedEvidenceIds(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecordStatusType(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsUserSelected(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addUnlinkedEvidenceIds(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addUnlinkedPolicyIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.ImportControl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.ImportControl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.ImportControl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.ImportControl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getObjective();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLinkedPolicyIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getLinkedEvidenceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRecordStatusType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsUserSelected();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getModelId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUnlinkedEvidenceIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getUnlinkedPolicyIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.importer.ImportControl.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string objective = 2;
 * @return {string}
 */
proto.importer.ImportControl.prototype.getObjective = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.setObjective = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string linked_policy_ids = 3;
 * @return {!Array<string>}
 */
proto.importer.ImportControl.prototype.getLinkedPolicyIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.setLinkedPolicyIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.addLinkedPolicyIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.clearLinkedPolicyIdsList = function() {
  return this.setLinkedPolicyIdsList([]);
};


/**
 * repeated string linked_evidence_ids = 4;
 * @return {!Array<string>}
 */
proto.importer.ImportControl.prototype.getLinkedEvidenceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.setLinkedEvidenceIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.addLinkedEvidenceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.clearLinkedEvidenceIdsList = function() {
  return this.setLinkedEvidenceIdsList([]);
};


/**
 * optional string url = 5;
 * @return {string}
 */
proto.importer.ImportControl.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.importer.ImportControl.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string record_status_type = 7;
 * @return {string}
 */
proto.importer.ImportControl.prototype.getRecordStatusType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.setRecordStatusType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool is_user_selected = 8;
 * @return {boolean}
 */
proto.importer.ImportControl.prototype.getIsUserSelected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.setIsUserSelected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string model_id = 9;
 * @return {string}
 */
proto.importer.ImportControl.prototype.getModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.setModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated string unlinked_evidence_ids = 10;
 * @return {!Array<string>}
 */
proto.importer.ImportControl.prototype.getUnlinkedEvidenceIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.setUnlinkedEvidenceIdsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.addUnlinkedEvidenceIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.clearUnlinkedEvidenceIdsList = function() {
  return this.setUnlinkedEvidenceIdsList([]);
};


/**
 * repeated string unlinked_policy_ids = 11;
 * @return {!Array<string>}
 */
proto.importer.ImportControl.prototype.getUnlinkedPolicyIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.setUnlinkedPolicyIdsList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.addUnlinkedPolicyIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.ImportControl} returns this
 */
proto.importer.ImportControl.prototype.clearUnlinkedPolicyIdsList = function() {
  return this.setUnlinkedPolicyIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.importer.ImportEvidence.repeatedFields_ = [4,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.ImportEvidence.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.ImportEvidence.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.ImportEvidence} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.ImportEvidence.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    docType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    linkedControlIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    url: jspb.Message.getFieldWithDefault(msg, 5, ""),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    recordStatusType: jspb.Message.getFieldWithDefault(msg, 7, ""),
    isUserSelected: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    unlinkedControlIdsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.ImportEvidence}
 */
proto.importer.ImportEvidence.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.ImportEvidence;
  return proto.importer.ImportEvidence.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.ImportEvidence} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.ImportEvidence}
 */
proto.importer.ImportEvidence.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addLinkedControlIds(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecordStatusType(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsUserSelected(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addUnlinkedControlIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.ImportEvidence.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.ImportEvidence.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.ImportEvidence} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.ImportEvidence.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDocType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLinkedControlIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRecordStatusType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsUserSelected();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getUnlinkedControlIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.importer.ImportEvidence.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportEvidence} returns this
 */
proto.importer.ImportEvidence.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.importer.ImportEvidence.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportEvidence} returns this
 */
proto.importer.ImportEvidence.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string doc_type = 3;
 * @return {string}
 */
proto.importer.ImportEvidence.prototype.getDocType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportEvidence} returns this
 */
proto.importer.ImportEvidence.prototype.setDocType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string linked_control_ids = 4;
 * @return {!Array<string>}
 */
proto.importer.ImportEvidence.prototype.getLinkedControlIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.importer.ImportEvidence} returns this
 */
proto.importer.ImportEvidence.prototype.setLinkedControlIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportEvidence} returns this
 */
proto.importer.ImportEvidence.prototype.addLinkedControlIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.ImportEvidence} returns this
 */
proto.importer.ImportEvidence.prototype.clearLinkedControlIdsList = function() {
  return this.setLinkedControlIdsList([]);
};


/**
 * optional string url = 5;
 * @return {string}
 */
proto.importer.ImportEvidence.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportEvidence} returns this
 */
proto.importer.ImportEvidence.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.importer.ImportEvidence.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportEvidence} returns this
 */
proto.importer.ImportEvidence.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string record_status_type = 7;
 * @return {string}
 */
proto.importer.ImportEvidence.prototype.getRecordStatusType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportEvidence} returns this
 */
proto.importer.ImportEvidence.prototype.setRecordStatusType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool is_user_selected = 8;
 * @return {boolean}
 */
proto.importer.ImportEvidence.prototype.getIsUserSelected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.importer.ImportEvidence} returns this
 */
proto.importer.ImportEvidence.prototype.setIsUserSelected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * repeated string unlinked_control_ids = 9;
 * @return {!Array<string>}
 */
proto.importer.ImportEvidence.prototype.getUnlinkedControlIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.importer.ImportEvidence} returns this
 */
proto.importer.ImportEvidence.prototype.setUnlinkedControlIdsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportEvidence} returns this
 */
proto.importer.ImportEvidence.prototype.addUnlinkedControlIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.ImportEvidence} returns this
 */
proto.importer.ImportEvidence.prototype.clearUnlinkedControlIdsList = function() {
  return this.setUnlinkedControlIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.GetImportWizardPoliciesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.GetImportWizardPoliciesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.GetImportWizardPoliciesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardPoliciesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pagination: (f = msg.getPagination()) && proto.importer.PaginationConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.GetImportWizardPoliciesRequest}
 */
proto.importer.GetImportWizardPoliciesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.GetImportWizardPoliciesRequest;
  return proto.importer.GetImportWizardPoliciesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.GetImportWizardPoliciesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.GetImportWizardPoliciesRequest}
 */
proto.importer.GetImportWizardPoliciesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = new proto.importer.PaginationConfig;
      reader.readMessage(value,proto.importer.PaginationConfig.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.GetImportWizardPoliciesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.GetImportWizardPoliciesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.GetImportWizardPoliciesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardPoliciesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.importer.PaginationConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.importer.GetImportWizardPoliciesRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.GetImportWizardPoliciesRequest} returns this
 */
proto.importer.GetImportWizardPoliciesRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PaginationConfig pagination = 2;
 * @return {?proto.importer.PaginationConfig}
 */
proto.importer.GetImportWizardPoliciesRequest.prototype.getPagination = function() {
  return /** @type{?proto.importer.PaginationConfig} */ (
    jspb.Message.getWrapperField(this, proto.importer.PaginationConfig, 2));
};


/**
 * @param {?proto.importer.PaginationConfig|undefined} value
 * @return {!proto.importer.GetImportWizardPoliciesRequest} returns this
*/
proto.importer.GetImportWizardPoliciesRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.importer.GetImportWizardPoliciesRequest} returns this
 */
proto.importer.GetImportWizardPoliciesRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.importer.GetImportWizardPoliciesRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.importer.GetImportWizardPoliciesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.GetImportWizardPoliciesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.GetImportWizardPoliciesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.GetImportWizardPoliciesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardPoliciesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    policiesList: jspb.Message.toObjectList(msg.getPoliciesList(),
    proto.importer.ImportPolicy.toObject, includeInstance),
    pagination: (f = msg.getPagination()) && proto.importer.PaginationConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.GetImportWizardPoliciesResponse}
 */
proto.importer.GetImportWizardPoliciesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.GetImportWizardPoliciesResponse;
  return proto.importer.GetImportWizardPoliciesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.GetImportWizardPoliciesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.GetImportWizardPoliciesResponse}
 */
proto.importer.GetImportWizardPoliciesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.importer.ImportPolicy;
      reader.readMessage(value,proto.importer.ImportPolicy.deserializeBinaryFromReader);
      msg.addPolicies(value);
      break;
    case 2:
      var value = new proto.importer.PaginationConfig;
      reader.readMessage(value,proto.importer.PaginationConfig.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.GetImportWizardPoliciesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.GetImportWizardPoliciesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.GetImportWizardPoliciesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardPoliciesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPoliciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.importer.ImportPolicy.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.importer.PaginationConfig.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ImportPolicy policies = 1;
 * @return {!Array<!proto.importer.ImportPolicy>}
 */
proto.importer.GetImportWizardPoliciesResponse.prototype.getPoliciesList = function() {
  return /** @type{!Array<!proto.importer.ImportPolicy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.importer.ImportPolicy, 1));
};


/**
 * @param {!Array<!proto.importer.ImportPolicy>} value
 * @return {!proto.importer.GetImportWizardPoliciesResponse} returns this
*/
proto.importer.GetImportWizardPoliciesResponse.prototype.setPoliciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.importer.ImportPolicy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportPolicy}
 */
proto.importer.GetImportWizardPoliciesResponse.prototype.addPolicies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.importer.ImportPolicy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.GetImportWizardPoliciesResponse} returns this
 */
proto.importer.GetImportWizardPoliciesResponse.prototype.clearPoliciesList = function() {
  return this.setPoliciesList([]);
};


/**
 * optional PaginationConfig pagination = 2;
 * @return {?proto.importer.PaginationConfig}
 */
proto.importer.GetImportWizardPoliciesResponse.prototype.getPagination = function() {
  return /** @type{?proto.importer.PaginationConfig} */ (
    jspb.Message.getWrapperField(this, proto.importer.PaginationConfig, 2));
};


/**
 * @param {?proto.importer.PaginationConfig|undefined} value
 * @return {!proto.importer.GetImportWizardPoliciesResponse} returns this
*/
proto.importer.GetImportWizardPoliciesResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.importer.GetImportWizardPoliciesResponse} returns this
 */
proto.importer.GetImportWizardPoliciesResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.importer.GetImportWizardPoliciesResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.GetImportWizardControlsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.GetImportWizardControlsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.GetImportWizardControlsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardControlsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pagination: (f = msg.getPagination()) && proto.importer.PaginationConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.GetImportWizardControlsRequest}
 */
proto.importer.GetImportWizardControlsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.GetImportWizardControlsRequest;
  return proto.importer.GetImportWizardControlsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.GetImportWizardControlsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.GetImportWizardControlsRequest}
 */
proto.importer.GetImportWizardControlsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = new proto.importer.PaginationConfig;
      reader.readMessage(value,proto.importer.PaginationConfig.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.GetImportWizardControlsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.GetImportWizardControlsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.GetImportWizardControlsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardControlsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.importer.PaginationConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.importer.GetImportWizardControlsRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.GetImportWizardControlsRequest} returns this
 */
proto.importer.GetImportWizardControlsRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PaginationConfig pagination = 2;
 * @return {?proto.importer.PaginationConfig}
 */
proto.importer.GetImportWizardControlsRequest.prototype.getPagination = function() {
  return /** @type{?proto.importer.PaginationConfig} */ (
    jspb.Message.getWrapperField(this, proto.importer.PaginationConfig, 2));
};


/**
 * @param {?proto.importer.PaginationConfig|undefined} value
 * @return {!proto.importer.GetImportWizardControlsRequest} returns this
*/
proto.importer.GetImportWizardControlsRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.importer.GetImportWizardControlsRequest} returns this
 */
proto.importer.GetImportWizardControlsRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.importer.GetImportWizardControlsRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.importer.GetImportWizardControlsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.GetImportWizardControlsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.GetImportWizardControlsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.GetImportWizardControlsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardControlsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlsList: jspb.Message.toObjectList(msg.getControlsList(),
    proto.importer.ImportControl.toObject, includeInstance),
    pagination: (f = msg.getPagination()) && proto.importer.PaginationConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.GetImportWizardControlsResponse}
 */
proto.importer.GetImportWizardControlsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.GetImportWizardControlsResponse;
  return proto.importer.GetImportWizardControlsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.GetImportWizardControlsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.GetImportWizardControlsResponse}
 */
proto.importer.GetImportWizardControlsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.importer.ImportControl;
      reader.readMessage(value,proto.importer.ImportControl.deserializeBinaryFromReader);
      msg.addControls(value);
      break;
    case 2:
      var value = new proto.importer.PaginationConfig;
      reader.readMessage(value,proto.importer.PaginationConfig.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.GetImportWizardControlsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.GetImportWizardControlsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.GetImportWizardControlsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardControlsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.importer.ImportControl.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.importer.PaginationConfig.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ImportControl controls = 1;
 * @return {!Array<!proto.importer.ImportControl>}
 */
proto.importer.GetImportWizardControlsResponse.prototype.getControlsList = function() {
  return /** @type{!Array<!proto.importer.ImportControl>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.importer.ImportControl, 1));
};


/**
 * @param {!Array<!proto.importer.ImportControl>} value
 * @return {!proto.importer.GetImportWizardControlsResponse} returns this
*/
proto.importer.GetImportWizardControlsResponse.prototype.setControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.importer.ImportControl=} opt_value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportControl}
 */
proto.importer.GetImportWizardControlsResponse.prototype.addControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.importer.ImportControl, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.GetImportWizardControlsResponse} returns this
 */
proto.importer.GetImportWizardControlsResponse.prototype.clearControlsList = function() {
  return this.setControlsList([]);
};


/**
 * optional PaginationConfig pagination = 2;
 * @return {?proto.importer.PaginationConfig}
 */
proto.importer.GetImportWizardControlsResponse.prototype.getPagination = function() {
  return /** @type{?proto.importer.PaginationConfig} */ (
    jspb.Message.getWrapperField(this, proto.importer.PaginationConfig, 2));
};


/**
 * @param {?proto.importer.PaginationConfig|undefined} value
 * @return {!proto.importer.GetImportWizardControlsResponse} returns this
*/
proto.importer.GetImportWizardControlsResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.importer.GetImportWizardControlsResponse} returns this
 */
proto.importer.GetImportWizardControlsResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.importer.GetImportWizardControlsResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.GetImportWizardEvidenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.GetImportWizardEvidenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.GetImportWizardEvidenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardEvidenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pagination: (f = msg.getPagination()) && proto.importer.PaginationConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.GetImportWizardEvidenceRequest}
 */
proto.importer.GetImportWizardEvidenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.GetImportWizardEvidenceRequest;
  return proto.importer.GetImportWizardEvidenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.GetImportWizardEvidenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.GetImportWizardEvidenceRequest}
 */
proto.importer.GetImportWizardEvidenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = new proto.importer.PaginationConfig;
      reader.readMessage(value,proto.importer.PaginationConfig.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.GetImportWizardEvidenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.GetImportWizardEvidenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.GetImportWizardEvidenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardEvidenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.importer.PaginationConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.importer.GetImportWizardEvidenceRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.GetImportWizardEvidenceRequest} returns this
 */
proto.importer.GetImportWizardEvidenceRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PaginationConfig pagination = 2;
 * @return {?proto.importer.PaginationConfig}
 */
proto.importer.GetImportWizardEvidenceRequest.prototype.getPagination = function() {
  return /** @type{?proto.importer.PaginationConfig} */ (
    jspb.Message.getWrapperField(this, proto.importer.PaginationConfig, 2));
};


/**
 * @param {?proto.importer.PaginationConfig|undefined} value
 * @return {!proto.importer.GetImportWizardEvidenceRequest} returns this
*/
proto.importer.GetImportWizardEvidenceRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.importer.GetImportWizardEvidenceRequest} returns this
 */
proto.importer.GetImportWizardEvidenceRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.importer.GetImportWizardEvidenceRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.importer.GetImportWizardEvidenceResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.GetImportWizardEvidenceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.GetImportWizardEvidenceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.GetImportWizardEvidenceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardEvidenceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    evidenceList: jspb.Message.toObjectList(msg.getEvidenceList(),
    proto.importer.ImportEvidence.toObject, includeInstance),
    pagination: (f = msg.getPagination()) && proto.importer.PaginationConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.GetImportWizardEvidenceResponse}
 */
proto.importer.GetImportWizardEvidenceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.GetImportWizardEvidenceResponse;
  return proto.importer.GetImportWizardEvidenceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.GetImportWizardEvidenceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.GetImportWizardEvidenceResponse}
 */
proto.importer.GetImportWizardEvidenceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.importer.ImportEvidence;
      reader.readMessage(value,proto.importer.ImportEvidence.deserializeBinaryFromReader);
      msg.addEvidence(value);
      break;
    case 2:
      var value = new proto.importer.PaginationConfig;
      reader.readMessage(value,proto.importer.PaginationConfig.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.GetImportWizardEvidenceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.GetImportWizardEvidenceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.GetImportWizardEvidenceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportWizardEvidenceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvidenceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.importer.ImportEvidence.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.importer.PaginationConfig.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ImportEvidence evidence = 1;
 * @return {!Array<!proto.importer.ImportEvidence>}
 */
proto.importer.GetImportWizardEvidenceResponse.prototype.getEvidenceList = function() {
  return /** @type{!Array<!proto.importer.ImportEvidence>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.importer.ImportEvidence, 1));
};


/**
 * @param {!Array<!proto.importer.ImportEvidence>} value
 * @return {!proto.importer.GetImportWizardEvidenceResponse} returns this
*/
proto.importer.GetImportWizardEvidenceResponse.prototype.setEvidenceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.importer.ImportEvidence=} opt_value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportEvidence}
 */
proto.importer.GetImportWizardEvidenceResponse.prototype.addEvidence = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.importer.ImportEvidence, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.GetImportWizardEvidenceResponse} returns this
 */
proto.importer.GetImportWizardEvidenceResponse.prototype.clearEvidenceList = function() {
  return this.setEvidenceList([]);
};


/**
 * optional PaginationConfig pagination = 2;
 * @return {?proto.importer.PaginationConfig}
 */
proto.importer.GetImportWizardEvidenceResponse.prototype.getPagination = function() {
  return /** @type{?proto.importer.PaginationConfig} */ (
    jspb.Message.getWrapperField(this, proto.importer.PaginationConfig, 2));
};


/**
 * @param {?proto.importer.PaginationConfig|undefined} value
 * @return {!proto.importer.GetImportWizardEvidenceResponse} returns this
*/
proto.importer.GetImportWizardEvidenceResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.importer.GetImportWizardEvidenceResponse} returns this
 */
proto.importer.GetImportWizardEvidenceResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.importer.GetImportWizardEvidenceResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.GetImportableTypesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.GetImportableTypesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.GetImportableTypesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportableTypesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.GetImportableTypesRequest}
 */
proto.importer.GetImportableTypesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.GetImportableTypesRequest;
  return proto.importer.GetImportableTypesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.GetImportableTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.GetImportableTypesRequest}
 */
proto.importer.GetImportableTypesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.GetImportableTypesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.GetImportableTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.GetImportableTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportableTypesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.importer.GetImportableTypesRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.GetImportableTypesRequest} returns this
 */
proto.importer.GetImportableTypesRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.ImportableType.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.ImportableType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.ImportableType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.ImportableType.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemTypeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.ImportableType}
 */
proto.importer.ImportableType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.ImportableType;
  return proto.importer.ImportableType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.ImportableType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.ImportableType}
 */
proto.importer.ImportableType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemTypeId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.ImportableType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.ImportableType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.ImportableType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.ImportableType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemTypeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string item_type_id = 1;
 * @return {string}
 */
proto.importer.ImportableType.prototype.getItemTypeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportableType} returns this
 */
proto.importer.ImportableType.prototype.setItemTypeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.importer.ImportableType.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.ImportableType} returns this
 */
proto.importer.ImportableType.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.importer.GetImportableTypesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.GetImportableTypesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.GetImportableTypesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.GetImportableTypesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportableTypesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemTypesList: jspb.Message.toObjectList(msg.getItemTypesList(),
    proto.importer.ImportableType.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.GetImportableTypesResponse}
 */
proto.importer.GetImportableTypesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.GetImportableTypesResponse;
  return proto.importer.GetImportableTypesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.GetImportableTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.GetImportableTypesResponse}
 */
proto.importer.GetImportableTypesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.importer.ImportableType;
      reader.readMessage(value,proto.importer.ImportableType.deserializeBinaryFromReader);
      msg.addItemTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.GetImportableTypesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.GetImportableTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.GetImportableTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetImportableTypesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.importer.ImportableType.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ImportableType item_types = 1;
 * @return {!Array<!proto.importer.ImportableType>}
 */
proto.importer.GetImportableTypesResponse.prototype.getItemTypesList = function() {
  return /** @type{!Array<!proto.importer.ImportableType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.importer.ImportableType, 1));
};


/**
 * @param {!Array<!proto.importer.ImportableType>} value
 * @return {!proto.importer.GetImportableTypesResponse} returns this
*/
proto.importer.GetImportableTypesResponse.prototype.setItemTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.importer.ImportableType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportableType}
 */
proto.importer.GetImportableTypesResponse.prototype.addItemTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.importer.ImportableType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.GetImportableTypesResponse} returns this
 */
proto.importer.GetImportableTypesResponse.prototype.clearItemTypesList = function() {
  return this.setItemTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.GetFrameworksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.GetFrameworksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.GetFrameworksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetFrameworksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.GetFrameworksRequest}
 */
proto.importer.GetFrameworksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.GetFrameworksRequest;
  return proto.importer.GetFrameworksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.GetFrameworksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.GetFrameworksRequest}
 */
proto.importer.GetFrameworksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.GetFrameworksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.GetFrameworksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.GetFrameworksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetFrameworksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.importer.GetFrameworksRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.GetFrameworksRequest} returns this
 */
proto.importer.GetFrameworksRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.Framework.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.Framework.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.Framework} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.Framework.toObject = function(includeInstance, msg) {
  var f, obj = {
    frameworkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.Framework}
 */
proto.importer.Framework.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.Framework;
  return proto.importer.Framework.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.Framework} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.Framework}
 */
proto.importer.Framework.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrameworkId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.Framework.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.Framework.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.Framework} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.Framework.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrameworkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string framework_id = 1;
 * @return {string}
 */
proto.importer.Framework.prototype.getFrameworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.Framework} returns this
 */
proto.importer.Framework.prototype.setFrameworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.importer.Framework.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.Framework} returns this
 */
proto.importer.Framework.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.importer.GetFrameworksResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.GetFrameworksResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.GetFrameworksResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.GetFrameworksResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetFrameworksResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    frameworksList: jspb.Message.toObjectList(msg.getFrameworksList(),
    proto.importer.Framework.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.GetFrameworksResponse}
 */
proto.importer.GetFrameworksResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.GetFrameworksResponse;
  return proto.importer.GetFrameworksResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.GetFrameworksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.GetFrameworksResponse}
 */
proto.importer.GetFrameworksResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.importer.Framework;
      reader.readMessage(value,proto.importer.Framework.deserializeBinaryFromReader);
      msg.addFrameworks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.GetFrameworksResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.GetFrameworksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.GetFrameworksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.GetFrameworksResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrameworksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.importer.Framework.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Framework frameworks = 1;
 * @return {!Array<!proto.importer.Framework>}
 */
proto.importer.GetFrameworksResponse.prototype.getFrameworksList = function() {
  return /** @type{!Array<!proto.importer.Framework>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.importer.Framework, 1));
};


/**
 * @param {!Array<!proto.importer.Framework>} value
 * @return {!proto.importer.GetFrameworksResponse} returns this
*/
proto.importer.GetFrameworksResponse.prototype.setFrameworksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.importer.Framework=} opt_value
 * @param {number=} opt_index
 * @return {!proto.importer.Framework}
 */
proto.importer.GetFrameworksResponse.prototype.addFrameworks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.importer.Framework, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.GetFrameworksResponse} returns this
 */
proto.importer.GetFrameworksResponse.prototype.clearFrameworksList = function() {
  return this.setFrameworksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.CancelImportWizardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.CancelImportWizardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.CancelImportWizardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.CancelImportWizardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    receptorId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.CancelImportWizardRequest}
 */
proto.importer.CancelImportWizardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.CancelImportWizardRequest;
  return proto.importer.CancelImportWizardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.CancelImportWizardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.CancelImportWizardRequest}
 */
proto.importer.CancelImportWizardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.CancelImportWizardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.CancelImportWizardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.CancelImportWizardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.CancelImportWizardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.importer.CancelImportWizardRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.CancelImportWizardRequest} returns this
 */
proto.importer.CancelImportWizardRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string receptor_id = 2;
 * @return {string}
 */
proto.importer.CancelImportWizardRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.CancelImportWizardRequest} returns this
 */
proto.importer.CancelImportWizardRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.CancelImportWizardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.CancelImportWizardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.CancelImportWizardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.CancelImportWizardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.CancelImportWizardResponse}
 */
proto.importer.CancelImportWizardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.CancelImportWizardResponse;
  return proto.importer.CancelImportWizardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.CancelImportWizardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.CancelImportWizardResponse}
 */
proto.importer.CancelImportWizardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.CancelImportWizardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.CancelImportWizardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.CancelImportWizardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.CancelImportWizardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.importer.CancelImportWizardResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.importer.CancelImportWizardResponse} returns this
 */
proto.importer.CancelImportWizardResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.importer.FinalizeImportWizardRequest.repeatedFields_ = [2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.FinalizeImportWizardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.FinalizeImportWizardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.FinalizeImportWizardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.FinalizeImportWizardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    policiesList: jspb.Message.toObjectList(msg.getPoliciesList(),
    proto.importer.ImportPolicy.toObject, includeInstance),
    controlsList: jspb.Message.toObjectList(msg.getControlsList(),
    proto.importer.ImportControl.toObject, includeInstance),
    evidencesList: jspb.Message.toObjectList(msg.getEvidencesList(),
    proto.importer.ImportEvidence.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.FinalizeImportWizardRequest}
 */
proto.importer.FinalizeImportWizardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.FinalizeImportWizardRequest;
  return proto.importer.FinalizeImportWizardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.FinalizeImportWizardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.FinalizeImportWizardRequest}
 */
proto.importer.FinalizeImportWizardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = new proto.importer.ImportPolicy;
      reader.readMessage(value,proto.importer.ImportPolicy.deserializeBinaryFromReader);
      msg.addPolicies(value);
      break;
    case 3:
      var value = new proto.importer.ImportControl;
      reader.readMessage(value,proto.importer.ImportControl.deserializeBinaryFromReader);
      msg.addControls(value);
      break;
    case 4:
      var value = new proto.importer.ImportEvidence;
      reader.readMessage(value,proto.importer.ImportEvidence.deserializeBinaryFromReader);
      msg.addEvidences(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.FinalizeImportWizardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.FinalizeImportWizardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.FinalizeImportWizardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.FinalizeImportWizardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPoliciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.importer.ImportPolicy.serializeBinaryToWriter
    );
  }
  f = message.getControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.importer.ImportControl.serializeBinaryToWriter
    );
  }
  f = message.getEvidencesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.importer.ImportEvidence.serializeBinaryToWriter
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.importer.FinalizeImportWizardRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.FinalizeImportWizardRequest} returns this
 */
proto.importer.FinalizeImportWizardRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ImportPolicy policies = 2;
 * @return {!Array<!proto.importer.ImportPolicy>}
 */
proto.importer.FinalizeImportWizardRequest.prototype.getPoliciesList = function() {
  return /** @type{!Array<!proto.importer.ImportPolicy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.importer.ImportPolicy, 2));
};


/**
 * @param {!Array<!proto.importer.ImportPolicy>} value
 * @return {!proto.importer.FinalizeImportWizardRequest} returns this
*/
proto.importer.FinalizeImportWizardRequest.prototype.setPoliciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.importer.ImportPolicy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportPolicy}
 */
proto.importer.FinalizeImportWizardRequest.prototype.addPolicies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.importer.ImportPolicy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.FinalizeImportWizardRequest} returns this
 */
proto.importer.FinalizeImportWizardRequest.prototype.clearPoliciesList = function() {
  return this.setPoliciesList([]);
};


/**
 * repeated ImportControl controls = 3;
 * @return {!Array<!proto.importer.ImportControl>}
 */
proto.importer.FinalizeImportWizardRequest.prototype.getControlsList = function() {
  return /** @type{!Array<!proto.importer.ImportControl>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.importer.ImportControl, 3));
};


/**
 * @param {!Array<!proto.importer.ImportControl>} value
 * @return {!proto.importer.FinalizeImportWizardRequest} returns this
*/
proto.importer.FinalizeImportWizardRequest.prototype.setControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.importer.ImportControl=} opt_value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportControl}
 */
proto.importer.FinalizeImportWizardRequest.prototype.addControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.importer.ImportControl, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.FinalizeImportWizardRequest} returns this
 */
proto.importer.FinalizeImportWizardRequest.prototype.clearControlsList = function() {
  return this.setControlsList([]);
};


/**
 * repeated ImportEvidence evidences = 4;
 * @return {!Array<!proto.importer.ImportEvidence>}
 */
proto.importer.FinalizeImportWizardRequest.prototype.getEvidencesList = function() {
  return /** @type{!Array<!proto.importer.ImportEvidence>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.importer.ImportEvidence, 4));
};


/**
 * @param {!Array<!proto.importer.ImportEvidence>} value
 * @return {!proto.importer.FinalizeImportWizardRequest} returns this
*/
proto.importer.FinalizeImportWizardRequest.prototype.setEvidencesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.importer.ImportEvidence=} opt_value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportEvidence}
 */
proto.importer.FinalizeImportWizardRequest.prototype.addEvidences = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.importer.ImportEvidence, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.FinalizeImportWizardRequest} returns this
 */
proto.importer.FinalizeImportWizardRequest.prototype.clearEvidencesList = function() {
  return this.setEvidencesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.FinalizeImportWizardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.FinalizeImportWizardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.FinalizeImportWizardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.FinalizeImportWizardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.FinalizeImportWizardResponse}
 */
proto.importer.FinalizeImportWizardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.FinalizeImportWizardResponse;
  return proto.importer.FinalizeImportWizardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.FinalizeImportWizardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.FinalizeImportWizardResponse}
 */
proto.importer.FinalizeImportWizardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.FinalizeImportWizardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.FinalizeImportWizardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.FinalizeImportWizardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.FinalizeImportWizardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.importer.FinalizeImportWizardResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.importer.FinalizeImportWizardResponse} returns this
 */
proto.importer.FinalizeImportWizardResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.AutoCollectRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.AutoCollectRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.AutoCollectRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.AutoCollectRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    discoveryId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.AutoCollectRequest}
 */
proto.importer.AutoCollectRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.AutoCollectRequest;
  return proto.importer.AutoCollectRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.AutoCollectRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.AutoCollectRequest}
 */
proto.importer.AutoCollectRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscoveryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.AutoCollectRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.AutoCollectRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.AutoCollectRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.AutoCollectRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDiscoveryId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.importer.AutoCollectRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.AutoCollectRequest} returns this
 */
proto.importer.AutoCollectRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string discovery_id = 2;
 * @return {string}
 */
proto.importer.AutoCollectRequest.prototype.getDiscoveryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.AutoCollectRequest} returns this
 */
proto.importer.AutoCollectRequest.prototype.setDiscoveryId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.AutoCollectResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.AutoCollectResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.AutoCollectResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.AutoCollectResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.AutoCollectResponse}
 */
proto.importer.AutoCollectResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.AutoCollectResponse;
  return proto.importer.AutoCollectResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.AutoCollectResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.AutoCollectResponse}
 */
proto.importer.AutoCollectResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.AutoCollectResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.AutoCollectResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.AutoCollectResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.AutoCollectResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.importer.AutoCollectResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.importer.AutoCollectResponse} returns this
 */
proto.importer.AutoCollectResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.importer.UpdateImportWizardPoliciesRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.UpdateImportWizardPoliciesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.UpdateImportWizardPoliciesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.UpdateImportWizardPoliciesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.UpdateImportWizardPoliciesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    policiesList: jspb.Message.toObjectList(msg.getPoliciesList(),
    proto.importer.ImportPolicy.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.UpdateImportWizardPoliciesRequest}
 */
proto.importer.UpdateImportWizardPoliciesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.UpdateImportWizardPoliciesRequest;
  return proto.importer.UpdateImportWizardPoliciesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.UpdateImportWizardPoliciesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.UpdateImportWizardPoliciesRequest}
 */
proto.importer.UpdateImportWizardPoliciesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = new proto.importer.ImportPolicy;
      reader.readMessage(value,proto.importer.ImportPolicy.deserializeBinaryFromReader);
      msg.addPolicies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.UpdateImportWizardPoliciesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.UpdateImportWizardPoliciesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.UpdateImportWizardPoliciesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.UpdateImportWizardPoliciesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPoliciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.importer.ImportPolicy.serializeBinaryToWriter
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.importer.UpdateImportWizardPoliciesRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.UpdateImportWizardPoliciesRequest} returns this
 */
proto.importer.UpdateImportWizardPoliciesRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ImportPolicy policies = 2;
 * @return {!Array<!proto.importer.ImportPolicy>}
 */
proto.importer.UpdateImportWizardPoliciesRequest.prototype.getPoliciesList = function() {
  return /** @type{!Array<!proto.importer.ImportPolicy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.importer.ImportPolicy, 2));
};


/**
 * @param {!Array<!proto.importer.ImportPolicy>} value
 * @return {!proto.importer.UpdateImportWizardPoliciesRequest} returns this
*/
proto.importer.UpdateImportWizardPoliciesRequest.prototype.setPoliciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.importer.ImportPolicy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportPolicy}
 */
proto.importer.UpdateImportWizardPoliciesRequest.prototype.addPolicies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.importer.ImportPolicy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.UpdateImportWizardPoliciesRequest} returns this
 */
proto.importer.UpdateImportWizardPoliciesRequest.prototype.clearPoliciesList = function() {
  return this.setPoliciesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.importer.UpdateImportWizardControlsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.UpdateImportWizardControlsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.UpdateImportWizardControlsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.UpdateImportWizardControlsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.UpdateImportWizardControlsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    controlsList: jspb.Message.toObjectList(msg.getControlsList(),
    proto.importer.ImportControl.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.UpdateImportWizardControlsRequest}
 */
proto.importer.UpdateImportWizardControlsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.UpdateImportWizardControlsRequest;
  return proto.importer.UpdateImportWizardControlsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.UpdateImportWizardControlsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.UpdateImportWizardControlsRequest}
 */
proto.importer.UpdateImportWizardControlsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = new proto.importer.ImportControl;
      reader.readMessage(value,proto.importer.ImportControl.deserializeBinaryFromReader);
      msg.addControls(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.UpdateImportWizardControlsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.UpdateImportWizardControlsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.UpdateImportWizardControlsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.UpdateImportWizardControlsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.importer.ImportControl.serializeBinaryToWriter
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.importer.UpdateImportWizardControlsRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.UpdateImportWizardControlsRequest} returns this
 */
proto.importer.UpdateImportWizardControlsRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ImportControl controls = 2;
 * @return {!Array<!proto.importer.ImportControl>}
 */
proto.importer.UpdateImportWizardControlsRequest.prototype.getControlsList = function() {
  return /** @type{!Array<!proto.importer.ImportControl>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.importer.ImportControl, 2));
};


/**
 * @param {!Array<!proto.importer.ImportControl>} value
 * @return {!proto.importer.UpdateImportWizardControlsRequest} returns this
*/
proto.importer.UpdateImportWizardControlsRequest.prototype.setControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.importer.ImportControl=} opt_value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportControl}
 */
proto.importer.UpdateImportWizardControlsRequest.prototype.addControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.importer.ImportControl, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.UpdateImportWizardControlsRequest} returns this
 */
proto.importer.UpdateImportWizardControlsRequest.prototype.clearControlsList = function() {
  return this.setControlsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.importer.UpdateImportWizardEvidenceRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.UpdateImportWizardEvidenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.UpdateImportWizardEvidenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.UpdateImportWizardEvidenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.UpdateImportWizardEvidenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    evidenceList: jspb.Message.toObjectList(msg.getEvidenceList(),
    proto.importer.ImportEvidence.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.UpdateImportWizardEvidenceRequest}
 */
proto.importer.UpdateImportWizardEvidenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.UpdateImportWizardEvidenceRequest;
  return proto.importer.UpdateImportWizardEvidenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.UpdateImportWizardEvidenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.UpdateImportWizardEvidenceRequest}
 */
proto.importer.UpdateImportWizardEvidenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = new proto.importer.ImportEvidence;
      reader.readMessage(value,proto.importer.ImportEvidence.deserializeBinaryFromReader);
      msg.addEvidence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.UpdateImportWizardEvidenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.UpdateImportWizardEvidenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.UpdateImportWizardEvidenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.UpdateImportWizardEvidenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEvidenceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.importer.ImportEvidence.serializeBinaryToWriter
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.importer.UpdateImportWizardEvidenceRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.importer.UpdateImportWizardEvidenceRequest} returns this
 */
proto.importer.UpdateImportWizardEvidenceRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ImportEvidence evidence = 2;
 * @return {!Array<!proto.importer.ImportEvidence>}
 */
proto.importer.UpdateImportWizardEvidenceRequest.prototype.getEvidenceList = function() {
  return /** @type{!Array<!proto.importer.ImportEvidence>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.importer.ImportEvidence, 2));
};


/**
 * @param {!Array<!proto.importer.ImportEvidence>} value
 * @return {!proto.importer.UpdateImportWizardEvidenceRequest} returns this
*/
proto.importer.UpdateImportWizardEvidenceRequest.prototype.setEvidenceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.importer.ImportEvidence=} opt_value
 * @param {number=} opt_index
 * @return {!proto.importer.ImportEvidence}
 */
proto.importer.UpdateImportWizardEvidenceRequest.prototype.addEvidence = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.importer.ImportEvidence, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.importer.UpdateImportWizardEvidenceRequest} returns this
 */
proto.importer.UpdateImportWizardEvidenceRequest.prototype.clearEvidenceList = function() {
  return this.setEvidenceList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.importer.UpdateImportWizardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.importer.UpdateImportWizardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.importer.UpdateImportWizardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.UpdateImportWizardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.importer.UpdateImportWizardResponse}
 */
proto.importer.UpdateImportWizardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.importer.UpdateImportWizardResponse;
  return proto.importer.UpdateImportWizardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.importer.UpdateImportWizardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.importer.UpdateImportWizardResponse}
 */
proto.importer.UpdateImportWizardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.importer.UpdateImportWizardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.importer.UpdateImportWizardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.importer.UpdateImportWizardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.importer.UpdateImportWizardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.importer.UpdateImportWizardResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.importer.UpdateImportWizardResponse} returns this
 */
proto.importer.UpdateImportWizardResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.importer.Status = {
  NOT_STARTED: 0,
  FETCHING_DATA: 1,
  COMPLETED: 2,
  FAILED: 3
};

/**
 * @enum {number}
 */
proto.importer.ImporterState = {
  IMPORTER_STATE_ADDED: 0,
  IMPORTER_STATE_REMOVED: 1,
  IMPORTER_STATE_MODIFIED: 2,
  IMPORTER_STATE_UNCHANGED: 3
};

goog.object.extend(exports, proto.importer);
